import script from "./AppTimeField.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppTimeField.vue?vue&type=script&setup=true&lang=ts"

import "./AppTimeField.vue?vue&type=style&index=0&id=6556808c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6556808c"]])

export default __exports__